export const STUDENT_ASSESSMENT_ATTEMPT_STATUS = Object.freeze({
  NONE: 0,
  IN_PROGRESS: 2,
  COMPLETED: 3,
});
